import { FormsRating, Text } from '@viapeople/components'
import type { FormComponent } from '../types'
import { EditableReportField } from './EditableReportField'
import type { BaseReportsProps } from './types'

export const RatingReports = ({ component, reports, allowCAEdit, taskId, refetch }: BaseReportsProps) => {
	// Suppress label in reports since report.label is already shown
	const componentWithoutLabel = Object.assign({}, component, {
		custom: Object.assign({}, component.custom || {}, {
			labelWeight: 'hidden' as const,
		}),
	}) as FormComponent

	return (
		<div className='flex flex-col gap-6'>
			{reports.map((report, reportIndex) => (
				<div key={report.label} className='print-keep-together'>
					<div className='mb-2'>
						<Text variant='small' weight='semibold' className='text-neutral-700'>
							{report.label}
						</Text>
					</div>

					<div className='flex flex-col gap-3'>
						{report.submissions.map((submission) => (
							<div key={submission.label} className='flex items-center gap-4 py-2 relative group overflow-visible'>
								<Text variant='xsmall' className='text-neutral-600'>
									{submission.label}
								</Text>
								<div className='bg-neutral-50 border border-neutral-200 rounded-md'>
									<FormsRating
										component={componentWithoutLabel}
										value={submission.value.split('(')[1]?.split(')')[0] || submission.value}
										onChange={() => {}}
										readOnly={true}
									/>
								</div>
								{allowCAEdit && taskId && (
									<EditableReportField
										taskId={taskId}
										componentId={component.id}
										currentValue={submission.value.split('(')[1]?.split(')')[0] || submission.value}
										label={submission.label}
										renderField={(value, onChange) => (
											<FormsRating
												component={componentWithoutLabel}
												value={value}
												onChange={onChange}
												readOnly={false}
											/>
										)}
										onSuccess={refetch}
									/>
								)}
							</div>
						))}
					</div>

					{reportIndex < reports.length - 1 && <div className='w-110 h-px bg-neutral-200 my-5' />}
				</div>
			))}
		</div>
	)
}
